import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EntryPass} from '../../../../../../../../../models/entry-pass';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { EntryPassService } from '../../../../../../../../../services/entry-pass/entry-pass.service';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { openClimberAppInNewTabAsCustomer } from '../../../../../../../../../utils-models';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';
import { Customer } from '../../../../../../../../../models/customer';
import { Association, AssociationManager } from '../../../../../../../../../models/association';
import { AssociationService } from '../../../../../../../../../services/association/association.service';
import { EntryPassStatus } from '../../../../../../../../../models/entry-pass-enums';

@Component({
  selector: 'app-purchase-customer-entry-pass-modal',
  templateUrl: './purchase-customer-entry-pass-modal.component.html',
  styleUrls: ['./purchase-customer-entry-pass-modal.component.css']
})
export class PurchaseCustomerEntryPassModalComponent implements OnInit {

  @Input() customer: Customer;
  @Input() association: Association;

  public customerId: number = null;
  public entryPassId: number = null;

  public entryPassList: EntryPass[];
  public associationManagerList: AssociationManager[];

  public loadingEntryPasses = false;
  public loadingAssociationManagers = false;
  public loadingSubmit = false;

  public serverError: number = null;

  public errors: any = {};
  public errorMessage = '';

  public EntryPassStatus = EntryPassStatus;

  constructor(
    private accountService: AccountService,
    private entryPassService: EntryPassService,
    private customerService: CustomerService,
    private associationService: AssociationService,
    private orgService: OrganizationConfigService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    if (this.customer) {
      this.customerId = this.customer.id;
    } else {
      this.customerId = null;
    }

    this.loadEntryPasses();

    if (!this.customerId) {
      this.loadAssociationManagers();
    }
  }

  public handleSave() {
    this.loadingSubmit = true;
    this.errors = {};
    this.errorMessage = '';

    if (this.customerId === null) {
      this.errorMessage = 'Please correct the errors above and try again.';
      this.errors = {
        customerId: 'Please select an association manager.'
      }
      return;
    }

    this.customerService
      .getCustomerClimberAppToken(this.customerId)
      .then(token => {
        const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
        let nextUrl: string;
        if (this.association) {
          nextUrl = baseUrl + 'pass/choose-members/' + this.entryPassId.toString() + '/' + this.association.id.toString() + '/';
        } else {
          nextUrl = baseUrl + 'pass/purchase-init/' + this.entryPassId.toString() + '/';
        }
        openClimberAppInNewTabAsCustomer(
          token,
          this.customerId,
          baseUrl,
          nextUrl
        );
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to purchase entry passes for this customer.';
        } else if (reason.status === 400) {
          this.errorMessage = 'Please correct the errors above and try again.';
          this.errors = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadEntryPasses() {
    this.loadingEntryPasses = true;

    this.entryPassService
      .getEntryPasses(
        1,
        100,
        {status: EntryPassStatus.active}
      )
      .then(response => {
        this.entryPassList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEntryPasses = false; });
  }

  private loadAssociationManagers() {
    this.loadingAssociationManagers = true;

    this.associationService
      .getAssociationManagers(1, 100, {association_id: this.association.id})
      .then(response => {
        this.associationManagerList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingAssociationManagers = false; });
  }

}
